import * as Sentry from '@sentry/browser'
import { ApiResponseError, isApiClientError } from '../default/ApiResponseError'
import { logApiClientError } from '../default/logApiClientError'

/**
 * Logs an error
 * @param {string} url
 * @param {Error} error
 * @param {boolean} rethrow
 * @param {boolean} skipK6
 */
export function captureMiddlewareError(
  url,
  error,
  rethrow = true,
  skipK6 = false,
) {
  const website = window.location.href
  const isK6Test = new URL(website).searchParams.get('skiptesting')
  if (isK6Test && skipK6) {
    return
  }

  // a 4xx means the request was refused, not that the middleware failed
  if (isApiClientError(error)) {
    logApiClientError(error)
    if (rethrow) {
      throw error
    }
    return
  }

  const name = `middleware-error@${url}`

  Sentry.captureException(error, (scope) => {
    scope.setTransactionName(name)

    scope.setTag('metric', 'middleware-error')

    if (error instanceof ApiResponseError) {
      scope.setTag('api_status', String(error.details.status))
      scope.setContext('api_response', { ...error.details })
    }

    if (isK6Test) {
      scope.setTag('k6', 'true')
    }

    return scope
  })
  console.error(error)
  if (rethrow) {
    throw error
  }
}
